import QuestionValue from "./QuestionValue";

export default class QuestionValueSum extends QuestionValue {
    constructor(left, operand, right) {
        if (typeof left !== "number" || typeof right !== "number")
            console.error("ensure pass a valid statement to QuestionValueSum");
        super(eval(left + operand + right));

        this._left = left;
        this._operand = operand;
        this._right = right;
    }

    toString() {
        return "" + this._left + "\n" + this._operand + " " + this._right;
    }

    set operand(value) {
        this._operand = value;
    }
}